import { render, staticRenderFns } from "./tsCheck.vue?vue&type=template&id=08071e18&scoped=true"
import script from "./tsCheck.vue?vue&type=script&lang=js"
export * from "./tsCheck.vue?vue&type=script&lang=js"
import style0 from "./tsCheck.vue?vue&type=style&index=0&id=08071e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08071e18",
  null
  
)

export default component.exports